import { Utils } from '../../fork-common-controls/utils.service';
import { GetBorrowerResponse } from '../index';
import OccupancyStatus = GetBorrowerResponse.OccupancyStatusEnum;

export class PersonalBorrower {
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  email: string;
  address: string;
  addressUnit: string;
  state: string;
  city: string;
  zipCode: string;
  occupancyStatus: string;
  paymentAmount: string;
  dob: string;
  yearlyIncome: string;
  phoneNumber: string;
  phoneType: string;

  constructor(borrowerResponse: GetBorrowerResponse) {
    this.firstName = borrowerResponse.firstName;
    this.lastName = borrowerResponse.lastName;
    this.suffix = borrowerResponse.nameSuffix;
    this.email = borrowerResponse.emailAddress;
    this.addressUnit = borrowerResponse.address.addressLine2;
    this.state = borrowerResponse.address.state;
    this.city = borrowerResponse.address.city;
    this.zipCode = borrowerResponse.address.zipCode;
    this.address = borrowerResponse.address.addressLine1;
    this.yearlyIncome = Utils.numberToCurrencyString(borrowerResponse.annualIncome, 0);
    this.dob = Utils.getDateString(borrowerResponse.dateOfBirth);
    this.occupancyStatus = OccupancyStatus[borrowerResponse.occupancyStatus];
    this.paymentAmount = Utils.numberToCurrencyString(borrowerResponse.homeMonthlyPayment, 0);
    this.phoneNumber = Utils.formatPhoneNumber(borrowerResponse.phoneNumber);

    // TODO: LDTSULA-2766 covers adding the phoneType field.
    // this.phoneType = borrowerResponse.phoneType;
  }
}
